import React from 'react';

/**
 * RealSpect brand mark: a yellow evidence-tent marker with the R drawn as a path,
 * so it renders crisply at any size without loading an image or a font.
 */
export default function BrandLogo({ className = 'w-7 h-7' }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={`${className} shrink-0`}
      role="img"
      aria-label="RealSpect"
    >
      <polygon points="44,6 50,6 60,58 54,58" fill="#c79f00" />
      <polygon points="4,58 14,6 44,6 54,58" fill="#f5c400" />
      <path
        fillRule="evenodd"
        fill="#14171c"
        d="M18 20 H30 C35.5 20 39 23.2 39 28 C39 31.9 36.7 34.7 33 35.6 L40 48 H33.2 L26.9 36 H24 V48 H18 Z M24 25 V31 H29.6 C31.8 31 33 29.9 33 28 C33 26.1 31.8 25 29.6 25 Z"
      />
    </svg>
  );
}
